import { permissionCheck } from '../../../../utils';

/**
 * created by tianruojun
 * 发布设置配置项
 */
export const publishInformationConfig = {
    modules: [
        {value: "selectColumn", check: true},
        {value: "synchronousContribute", check: () => {
            return permissionCheck('contribute_power');
        }},
        {value: "otherAttributes", check: true},
        {value: "otherSetting", check: true},
    ]
};

/**
 *  发布配置动态修改函数
 */
export function publishInformationConfigFn() {
    let newList = [];
    publishInformationConfig.modules.forEach(item=>{
        if(typeof item.check === "boolean") {
            if(item.check) {
                newList.push(item.value)
            }
        } else if(typeof item.check === "function") {
            if(item.check()) {
                newList.push(item.value)
            }
        } else {
            console.log("ERROR: check is not a boolean or function")
        }
    });
    return {
        ...publishInformationConfig,
        modules:newList
    }
};